import FileDownloadIcon from "@mui/icons-material/FileDownload";
// material
import { styled } from "@mui/material/styles";
import {
  Toolbar,
  Stack,
  Typography,
  OutlinedInput,
  InputAdornment,
  Button,
} from "@mui/material";
import { getTodayDate, parseDate } from "../../utils/tableFunctions";
import { CSVLink } from "react-csv";
import Filter from "../table/Filter";
import Search from "@mui/icons-material/Search";
import { useState } from "react";
import { useRef } from "react";
import { LoadingButton } from "@mui/lab";
import * as XLSX from "xlsx";
// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 70,
  display: "flex",
  justifyContent: "space-between",
  padding: theme.spacing(0, 1, 0, 3),
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(["box-shadow", "width"], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  "&.Mui-focused": { width: 320, boxShadow: theme.customShadows.z8 },
  "& fieldset": {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`,
  },
}));

// ----------------------------------------------------------------------

const CSVButton = ({ filename, getCSVData }) => {
  const csvLink = useRef(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    getCSVData()
      .then((e) => downloadExcel(e, filename))
      .then(() => setLoading(false));
    // .then(() => document.getElementById("csvlink").click())
  };

  const downloadExcel = (data, filename) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
    //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workbook, filename);
  };

  return (
    <div>
      {/* <LoadingButton variant="outlined" onClick={fetchData} loading={loading}>
        <FileDownloadIcon sx={{ mr: 1 }} />
        Export CSV
      </LoadingButton>

      <CSVLink
        id="csvlink"
        data={data}
        filename={filename}
        className="hidden"
        ref={csvLink}
        target="_blank"
      /> */}
      <LoadingButton variant="outlined" onClick={fetchData} loading={loading}>
        <FileDownloadIcon sx={{ mr: 1 }} />
        Download As xlsx
      </LoadingButton>
    </div>
  );
};

export default function ListToolbar({
  numSelected,
  filterName,
  onFilterName,
  filter,
  filterFunction,
  onFilterSubmit,
  loaded,
  setReset,
  getCSVData = false,
  type,
  date,
  search = false,
  error = false
}) {
  const getFileName = () => {
    return type + "-" + getTodayDate() + ".xlsx";
  };

  return (
    <RootStyle
      sx={{
        ...(numSelected > 0 && {
          color: "primary.main",
          bgcolor: "primary.lighter",
        }),
      }}
    >
      {numSelected > 0 && (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      )}

      <SearchStyle
        sx={{ visibility: search ? "visible" : "hidden" }}
        value={filterName}
        onChange={onFilterName}
        placeholder="Search..."
        startAdornment={
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        }
      />

      {date && date?.[0] && date?.[1] && !error && (
        <Typography
          sx={{
            position: "absolute",
            marginLeft: "auto",
            marginRight: "auto",
            textAlign: "center",
            left: 0,
            right: 0,
          }}
        >{`${parseDate(date[0])}  -  ${parseDate(date[1])}`}</Typography>
      )}

      {/* {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <Delete />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton>
            <FilterAlt />
          </IconButton>
        </Tooltip>
      )} */}
      <Stack direction="row" spacing={1}>
        {getCSVData && (
          <CSVButton filename={getFileName()} getCSVData={getCSVData} />
        )}
        {filter && loaded && (
          <Filter
            renderContent={filterFunction}
            // type={type}
            onSubmit={onFilterSubmit}
            setReset={setReset}
            error={error}
          />
        )}
      </Stack>
    </RootStyle>
  );
}
